<script>
import ListBrand from '@components/List/Brand'
import ListContact from '@components/List/Contact'
import ListInfo from '@components/List/Info'
import { conditionList } from '@utils/is-condition'
import { eventIsDealerOnly, eventLocationContent, eventLocationTitle, eventRegistrationDateRange, eventSessionTimeTitle } from '@utils/zerone-event'
import { eventTagStatusItem } from '@utils/zerone-event-status'
import { FAKE_EVENT_ITEM } from '@src/config/fake-evnet'

export default {
  components: {
    ListBrand,
    ListContact,
    ListInfo,
  },
  props: {
    eventItem: {
      type: Object,
      default: () => {
        return FAKE_EVENT_ITEM
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    tagStatusItem() {
      return eventTagStatusItem({
        ...this.eventItem,
      })
    },
    isShowContact() {
      return this.eventItem.contact[0]
    },
    isDealerOnly() {
      return eventIsDealerOnly({ ...this.eventItem })
    },
    registrationDateRange() {
      return eventRegistrationDateRange({ ...this.eventItem })
    },
    locationContent() {
      return eventLocationContent({
        ...this.eventItem,
        eventType: this.eventItem.type,
      })
    },
    locationTitle() {
      return eventLocationTitle(this.eventItem.type, this.eventItem.categoryTitle)
    },
    sessionTimeTitle() {
      return eventSessionTimeTitle(this.eventItem.type, this.eventItem.categoryTitle)
    },
    infoList() {
      return conditionList([
        // {
        //   title: '<i class="icomoon icon-time mr-2"></i>報名時間',
        //   text: this.registrationDateRange,
        //   class: 'col-md-6',
        // },
        {
          title: `<i class="icomoon icon-time mr-2"></i>${this.sessionTimeTitle}`,
          text: this.eventItem.dateTimeRange,
          class: 'col-md-6',
        },
        {
          title: `<i class="icomoon icon-location mr-2"></i>${this.locationTitle}`,
          text: this.locationContent,
          class: 'col-md-6',
        },
        {
          type: 'tag',
          title: `<i class="icomoon icon-calender mr-2"></i>${this.eventItem.categoryTitle || '活動'}狀態`,
          text: this.tagStatusItem.title,
          textClass: this.tagStatusItem.class,
          class: 'col-md-6',
        },
        {
          title: `<i class="icomoon icon-lock-icon mr-2"></i>${this.eventItem.categoryTitle || '活動'}對象`,
          text: [
            this.isDealerOnly ? `<span class="color-primary">經銷商限定</span>` : '',
            this.eventItem.requireCoupon ? `<span class="color-primary">指定上課券報名</span>` : '',
            this.eventItem.requiredEvent[0] ? `<span class="color-primary">需先參加指定課程</span>` : '',
          ]
            .filter((item) => !!item)
            .join('<br>'),
          class: 'col-md-6',
          condition: () => {
            return this.isDealerOnly || !!this.eventItem.requireCoupon || !!this.eventItem.requiredEvent[0]
          },
        },
      ])
    },
  },
  methods: {},
}
</script>

<template>
  <div :class="$style.sectionCourseAbout" class="section">
    <div class="container">
      <BaseSectionTitle :title="`${eventItem.categoryTitle || '活動'}簡介`" class="text-center d-lg-block d-none" />
      <div :class="$style.courseAbout">
        <div class="row no-gutters">
          <div class="col-xl-7 col-12 courseAbout__info">
            <div class="row">
              <div class="col-12">
                <div class="row no-gutters">
                  <div class="col-lg-5 col-12 imgBox">
                    <ListBrand :brand-list="eventItem.brands">
                      <div v-if="isShowContact" class="col-4 d-lg-none ml-auto text-center align-self-center">
                        <el-popover placement="bottom" trigger="click" popper-class="isStyleBase isStyleContact">
                          <ListContact title="" type="event" :brand-list="eventItem.contact" />
                          <el-button slot="reference" class="isStyleContact">洽詢專線 <i class="fas fa-caret-down"></i></el-button>
                        </el-popover>
                      </div>
                    </ListBrand>
                  </div>
                  <div class="col-lg-6 col-12 contact d-lg-block d-none">
                    <template v-if="isShowContact">
                      <hr class="d-sm-none" />
                      <ListContact title="洽詢專線" type="event" :brand-list="eventItem.contact" />
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-md-5 my-4" />
            <ListInfo :info-list="infoList" class="row" />
          </div>
          <div class="col-xl-5 col-12">
            <div class="courseAbout__content">
              <hr class="d-lg-none" />
              <BaseSectionTitle :title="`${eventItem.categoryTitle || '活動'}簡介`" class="text-center d-lg-none" />
              <div class="courseAbout__contentIntrotext" v-html="eventItem.introtext"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.sectionCourseAbout {
  :global {
    .sectionCourseAbout {
    }
  }
}

.courseAbout {
  background-color: $color-gray-2;
  box-shadow: 0 2px 10px rgba(33, 69, 88, 0.16);
  @include max-lg {
    box-shadow: none;
    background: transparent;
  }

  :global {
    .col-md {
      display: flex;
      align-items: center;
    }

    .courseAbout {
      &__info {
        padding-top: 3.75rem;
        padding-right: 3rem;
        padding-bottom: 3.75rem;
        padding-left: 3rem;
        background-color: #fff;

        @include max-md {
          padding: 0;
        }

        .imgBox {
          align-self: center;
          margin-right: 30px;

          i {
            margin-right: 8px;
          }

          .link {
            display: flex;
            justify-content: space-between;
            color: $color-gray-7;

            .img {
              width: 190px;
              margin-right: 19px;
            }
          }
        }

        .contact {
          padding-left: 45px;
          border-left: 1px solid #e6e6e6;

          @include max-md {
            padding-left: 0;
            border-left: 0;
          }
        }
      }
      &__content {
        // display: flex;
        // align-items: center;
        width: 100%;
        padding: 2rem;
        line-height: 2;
        //  display: flex;
        //  flex-wrap:wrap;
        //  align-items: center;
        // background-color: $color-gray-2;
        @include max-md {
          padding: 0;
        }
      }
      &__contentIntrotext {
        table {
          max-width: 100%;
        }
        img {
          max-width: 100%;
          height: auto;
        }
        iframe {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
